import {
  FilterActions,
  FilterLabels,
  FilterSelectedValue,
  FilterType,
  trackMainFilterSelection,
} from '@aboutyou/legacy-tracking-sdk';
import {useCallback} from 'react';
import {getCurrentSelectionForSlug} from '../utils/getFilterData';
import {useTracking} from '../utils/utils';

export const useTrackFilter = () => {
  const {TrackingClient} = useTracking();

  return useCallback(
    (
      slug: string,
      selectedValue: FilterSelectedValue,
      filterType: FilterType,
      action: FilterActions,
      label: FilterLabels,
    ) => {
      const {selection} = getCurrentSelectionForSlug({
        slug,
        selectedValue,
        filterType,
      })();

      TrackingClient.track(
        trackMainFilterSelection({selection, action, label}),
      );
    },
    [TrackingClient],
  );
};

export const useTrackOnCloseFilter = () => {
  const filterTracker = useTrackFilter();

  return (
    filterSlug: string,
    label: FilterLabels,
    selectedValue?: FilterSelectedValue,
    filterType?: FilterType,
  ) => {
    filterTracker(
      filterSlug,
      selectedValue ?? [],
      filterType ?? 'attribute',
      'close',
      label,
    );
  };
};

export const useTrackOnOpenFilter = () => {
  const filterTracker = useTrackFilter();

  return (
    filterSlug: string,
    label: FilterLabels,
    selectedValue?: FilterSelectedValue,
    filterType?: FilterType,
  ) => {
    filterTracker(
      filterSlug,
      selectedValue ?? [],
      filterType ?? 'attribute',
      'click',
      label,
    );
  };
};

export const useTrackOnFilterOpen = () => {
  const filterTracker = useTrackFilter();

  return (
    filterSlug: string,
    label: FilterLabels,
    selectedValue?: FilterSelectedValue,
    filterType?: FilterType,
  ) => {
    filterTracker(
      filterSlug,
      selectedValue ?? [],
      filterType ?? 'attribute',
      'open',
      label,
    );
  };
};
